import type { ValueHandler } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
import { handleSignature } from '@/value-handlers/signature'
import { handlePersonsAddress } from '@/value-handlers/persons-address'
import { handleElhubController } from '@/value-handlers/elhub-controller.ts'

export const VALUE_HANDLERS: Record<string, ValueHandler> = {
	'elhub-controller': handleElhubController,
	'signature': handleSignature,
	'persons-address': handlePersonsAddress,
}